import { Component } from '@angular/core';

// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

// 2. Interface for Project Items
export interface ProjectItem {
  image: string;
  title: string;
  category: string;
  link: string;
  delay: string;
}

@Component({
  selector: 'app-portfolio',
  standalone: false,
  templateUrl: './portfolio.component.html',
  styleUrl: './portfolio.component.css'
})
export class PortfolioComponent {
  // Fun Facts Data Array
  facts: FactItem[] = [
    {
      value: '99',
      label: 'Success in getting happy customer',
      delay: '.1s'
    },
    {
      value: '25',
      label: 'Thousands of successful business',
      delay: '.3s'
    },
    {
      value: '120',
      label: 'Total clients who love HighTech',
      delay: '.5s'
    },
    {
      value: '5',
      label: 'Stars reviews given by satisfied clients',
      delay: '.7s'
    }
  ];

  // Lifecycle Hooks
  ngOnInit(): void {
    // Initialization code (if any)
  }

  ngOnDestroy(): void {
    // Cleanup code (if any)
  }

  // Projects Data Array
  projects: ProjectItem[] = [
    {
      image: 'assets/images/project-1.jpg',
      title: 'UI/UX Design',
      category: 'Web Analysis',
      link: '/portfolio',
      delay: '.3s'
    },
    {
      image: 'assets/images/project-2.jpg',
      title: 'App Development',
      category: 'Cyber Security Core',
      link: '/portfolio',
      delay: '.5s'
    },
    {
      image: 'assets/images/project-3.jpg',
      title: 'Responsive',
      category: 'Upcomming Phone',
      link: '/portfolio',
      delay: '.7s'
    },
    {
      image: 'assets/images/project-4.jpg',
      title: 'Angular',
      category: 'Web Analysis',
      link: '/portfolio',
      delay: '.3s'
    },
    {
      image: 'assets/images/project-5.jpg',
      title: 'Digital Marketing',
      category: 'Marketing Analysis',
      link: '/portfolio',
      delay: '.5s'
    },
    {
      image: 'assets/images/project-6.jpg',
      title: '24/7 Support',
      category: 'keyword Analysis',
      link: '/portfolio',
      delay: '.7s'
    }
  ];
}
